const thermo = {
  logo: require("@/assets/thermo/thermo-logo-text.svg"),
};

export default thermo;
